import React from 'react';
import { useTheme, themes } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

export default function Settings() {
  const { theme, selectTheme } = useTheme();
  const { user, userProfile } = useAuth();

  return (
    <div style={{ padding: '2rem', maxWidth: '700px' }} className="animate-fade">
      <h1 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '1.8rem', fontWeight: 700, color: theme.text, marginBottom: '2rem' }}>
        ⚙️ Settings
      </h1>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <h3 style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, color: theme.text, marginBottom: '1rem' }}>Account</h3>
        <div style={{ display: 'grid', gap: '0.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: `1px solid ${theme.border}` }}>
            <span style={{ color: theme.textSecondary }}>Name</span>
            <span style={{ color: theme.text, fontWeight: 600 }}>{user?.displayName || '--'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: `1px solid ${theme.border}` }}>
            <span style={{ color: theme.textSecondary }}>Email</span>
            <span style={{ color: theme.text }}>{user?.email}</span>
          </div>
          {userProfile && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: `1px solid ${theme.border}` }}>
                <span style={{ color: theme.textSecondary }}>Goal Weight</span>
                <span style={{ color: theme.text }}>{userProfile.goals?.targetWeight} lbs</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0' }}>
                <span style={{ color: theme.textSecondary }}>Primary Goal</span>
                <span style={{ color: theme.text }}>{userProfile.goals?.primaryGoal}</span>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="card">
        <h3 style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 600, color: theme.text, marginBottom: '1rem' }}>Theme</h3>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          {Object.values(themes).map(t => (
            <button key={t.name} onClick={() => selectTheme(t.name)} style={{
              padding: '1rem 1.5rem', borderRadius: '12px', cursor: 'pointer',
              background: t.bgCard, border: `2px solid ${theme.name === t.name ? t.accent : t.border}`,
              color: t.text, transition: 'all 0.2s ease', fontFamily: "'Rajdhani', sans-serif", fontWeight: 600,
              boxShadow: theme.name === t.name ? `0 0 16px ${t.accent}44` : 'none',
            }}>
              {t.name === 'dark' ? '🌙' : '☀️'} {t.label}
              {theme.name === t.name && <span style={{ marginLeft: '0.5rem', color: t.accent }}>✓</span>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
